
import { useEffect } from 'react'

/* Common ======================================================================================= */
import { get } from '../../../share/find'
import { getCurrentUser } from '../../../services/auth'

/* Contents ===================================================================================== */
import { GLOBAL_CONTENTS } from '../../../common/global-contents'

/* Hooks ======================================================================================== */
import useBoolean from '../../../hooks/use-boolean'
import useFetch from '../../../hooks/use-fetch'
import useLocal from '../../../hooks/use-local'
import useValue from '../../../hooks/use-value'

/* Components =================================================================================== */
import Skeleton from '../../../components/skeleton'
import { Box } from '../../../components/box/box.component'
import { Button } from '../../../components/button'
import { Form } from '../../../components/form'
import { Line } from '../../../components/line'
import { Loader } from '../../../components/loader'
import { Modal } from '../../../components/modal'
import { Notification } from '../../../components/notification'
import { renderForm } from '../../../modules/handlers/render-form'

/* Styles ======================================================================================= */
import { mb12 } from '../../../styles/styleset/margin/mb12'
import { mb4 } from '../../../styles/styleset/margin/mb4'
import { mr8 } from '../../../styles/styleset/margin/mr8'
import { p12 } from '../../../styles/styleset/padding/p12'

Modal.add('ContactUs', (props: any) => {
  const cleanFields = (payload: any) => {
    const fields = get('base.form.fields', payload, 'array')

    if (fields.length > 0) {
      const { currentUser } = getCurrentUser()

      if (currentUser && currentUser.email) {
        fields[1].disabled = true
      }
    }

    return fields
  }

  const [local] = useLocal()
  const [values, $values] = useValue({
    ...(props.values || {}),
    email: getCurrentUser().currentUser ? getCurrentUser().currentUser.email : '',
  })
  const [fields, $fields] = useValue([])
  const [, $isSubmiited] = useBoolean(false)
  const [meta, $meta] = useFetch(
    {
      base: {
        sections: [],
      },
    },
    {
      url: `${process.env.REACT_APP_API_URL}/a/contact-us`,
    },
  )

  const [a, $a] = useFetch(
    {
      body: {
        body: [],
      },
    },
    {
      url: `${process.env.REACT_APP_API_URL}/a/contact-us`,
    },
  )

  useEffect(() => {
    if (meta.mounted) {
      $meta.get().then((payload: any) => {
        $fields.set(cleanFields(payload))

        $values.set((prev: any) => ({
          ...prev,
          ticketType: props?.values?.ticketType || payload.base.form.fields[0].value,
        }))
      })
    }
  }, [meta.mounted])

  return (
    <Box onClick={props.handleContentClick} rounded minWidth={300}>
      <Form
        key={0}
        values={values}
        onSubmit={(data: any) => {
          $isSubmiited.set(true)

          $fields.set((prev: any) => {
            return prev.map((field: any) => {
              return {
                ...field,
                disabled: true,
              }
            })
          })

          if (!a.meta.isLoading) {
            $a.post({ body: data }).then(() => {
              Modal.pop()
              Notification.push({ label: props?.confirmMessage || 'Inquiry sent!' })
            })
            $values.set(data)
          }

          props?.onClick?.()
        }}
      >
        <Box baseline="none" maxHeight={420}>
          <Loader
            loaded={!!fields.length}
            skeleton={
              <Box className={p12} row flex>
                <Skeleton width="40%" height={14} className={mb4} />
                <Skeleton width="100%" height={32} className={mb12} />
                <Skeleton width="40%" height={14} className={mb4} />
                <Skeleton width="100%" height={32} className={mb12} />
                <Skeleton width="40%" height={14} className={mb4} />
                <Skeleton width="100%" height={80} className={mb12} />
                <Skeleton width="100%" height={32} />
              </Box>
            }
            component={
              <Box baseline="none" row>
                <Box baseline="none" className={p12} spaceBetween fullWidth row>
                  {fields.map((field: any) => {
                    return renderForm({
                      field,
                      parentName: '',
                      values,
                      entryUrl: `${process.env.REACT_APP_API_URL}/app`,
                      isFromView: true,
                    })
                  })}
                  <Box />
                </Box>
                <Line />
                <Box baseline="none" spaceBetween className={p12}>
                  <Box baseline="none" />
                  <Box baseline="none" column>
                    <Button
                      className={mr8}
                      onClick={Modal.pop}
                      label={GLOBAL_CONTENTS.close[local]}
                      baseline="background"
                      size="md"
                      square
                    />

                    <Button
                      label={
                        a.meta.isLoading
                          ? `${GLOBAL_CONTENTS.loading[local]} ...`
                          : GLOBAL_CONTENTS.submit[local]
                      }
                      type={a.meta.isLoading ? 'button' : 'submit'}
                      baseline="primary"
                      size="md"
                      square
                    />
                  </Box>
                </Box>
              </Box>
            }
          />
        </Box>
      </Form>
    </Box>
  )
})
